import api from './api';

const cashSessionService = {
  /**
   * Obtener todas las sesiones (con paginación)
   */
  getAll: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.cash_register_id) {
        params.append('cash_register_id', filters.cash_register_id);
      }
      
      if (filters.punto_venta_id) {
        params.append('punto_venta_id', filters.punto_venta_id);
      }
      
      if (filters.estado) {
        params.append('estado', filters.estado);
      }
      
      if (filters.fecha_desde) {
        params.append('fecha_desde', filters.fecha_desde);
      }
      
      if (filters.fecha_hasta) {
        params.append('fecha_hasta', filters.fecha_hasta);
      }
      
      if (filters.per_page) {
        params.append('per_page', filters.per_page);
      }

      const response = await api.get(`/cash-sessions?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching cash sessions:", error);
      throw error;
    }
  },

  /**
   * Obtener la sesión activa
   */
  getActive: async (cashRegisterId = null) => {
    try {
      const params = cashRegisterId 
        ? `?cash_register_id=${cashRegisterId}` 
        : '';
      
      const response = await api.get(`/cash-sessions/active${params}`);
      return response.data;
    } catch (error) {
      // Si no hay sesión activa, retornar null en lugar de error
      if (error.response?.status === 404) {
        return { success: false, data: null };
      }
      console.error("Error fetching active session:", error);
      throw error;
    }
  },

  /**
   * Abrir una nueva sesión de caja
   */
  open: async (data) => {
    try {
      const response = await api.post('/cash-sessions/open', data);
      return response.data;
    } catch (error) {
      console.error("Error opening cash session:", error);
      throw error;
    }
  },

  /**
   * Cerrar una sesión de caja
   */
  close: async (sessionId, data) => {
    try {
      const response = await api.post(`/cash-sessions/${sessionId}/close`, data);
      return response.data;
    } catch (error) {
      console.error("Error closing cash session:", error);
      throw error;
    }
  },

  /**
   * Obtener detalles de una sesión específica
   */
  getById: async (sessionId) => {
    try {
      const response = await api.get(`/cash-sessions/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching session details:", error);
      throw error;
    }
  },

  /**
   * Registrar un retiro de efectivo
   */
  registerWithdrawal: async (sessionId, data) => {
    try {
      const response = await api.post(
        `/cash-sessions/${sessionId}/withdrawal`, 
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error registering withdrawal:", error);
      throw error;
    }
  },

  /**
   * Registrar un ingreso de efectivo
   */
  registerIncome: async (sessionId, data) => {
    try {
      const response = await api.post(
        `/cash-sessions/${sessionId}/income`, 
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error registering income:", error);
      throw error;
    }
  },

  /**
   * Obtener movimientos de una sesión
   */
  getMovements: async (sessionId) => {
    try {
      const response = await api.get(`/cash-sessions/${sessionId}/movements`);
      return response.data;
    } catch (error) {
      console.error("Error fetching movements:", error);
      throw error;
    }
  },
};

export default cashSessionService;